module.exports = __webpack_public_path__ + "static/media/SourceSansPro-Bold.f14b179b.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/SourceSansPro-Bold.ttf
// module id = 350
// module chunks = 3